import useAttendance from 'v3/pages/ControlTower/Kanban/Attendance/useAttendance';
import AttendanceNotice from 'v3/pages/ControlTower/Kanban/Attendance/Notice';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { FaExclamationCircle } from 'react-icons/fa';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import DropdownButton from 'v3/components/DropdownButton';
import ApplicationLayout from 'v3/layouts/Application';
import { useSnackbar } from 'v3/components/Snackbar';
import {
  makeConversion,
  currencyOptions,
} from 'v3/utils/formatter';
import {
  validateStartSchedule,
  validateBranchOffice,
  validatePolicyValidity,
} from 'v3/validators/loadValidators';
import api, { cooperplaceApi } from 'services/api';
import { validatePermission } from 'actions/index';
import { Card, Badge } from 'v3/components';
import { HiOutlineExternalLink } from 'react-icons/hi';
import { getRate } from 'v3/utils/rate';
import { useModal, usePermission } from 'hooks';
import { BlockedTravelContext } from 'contexts/BlockedTravelProvider';
import moment from 'moment';
import { UserContext } from 'contexts/UserContext';
import { DELIVERY_TYPE_OPTIONS, UNDER_GRO_ANALYSIS_SLUG } from 'v3/utils/constants';
import { MinimumMarginModal } from 'v3/pages/Travel/shared';
import {
  InsuranceValueContextProvider
} from 'contexts/InsuranceValueContext';
import {
  loadReplacementToFreightData,
  loadToFreightData,
  toReplacementPayload,
} from 'v3/components/FreightValues/utils';
import { Badge as StyledBadge } from '../List/Card/styles';
import Data from './Data';
import Locale from './Locale';
import Vehicle from './Vehicle';
import Monitoring from './Monitoring';
import Automations from './Automations';
import Integrations from './Integrations';
import CancelLoad from './ModalCancelLoad';
import Visualizations from './Visualizations';
import ModalRenewLoad from '../List/Card/ModalRenewLoad';
import { confirmOption } from './ModalCancelLoad/controller';
import { AttemptRegisterLoad } from '../Modals/attemptRegisterLoad';
import { GroAttended } from './Modals/GroAttended';
import FreightValues from './FreightValues';
import { fetchCountries } from 'utils/fetches';
import { normalizeTollsPlazaResponse } from 'v3/components/TravelRouteCard/TollsPlazaCalculation';

function RenderLoadLabel({ isTravelBlocked, isTravelReproved, load }) {
  const renderBadge = () => {
    if (isTravelReproved) {
      return (
        <>
          <StyledBadge type="error" className="mx-2" size="sm" pill light>
            <Text type="label">Reprovada</Text>
          </StyledBadge>
        </>
      );
    }

    if (isTravelBlocked) {
      return (
        <StyledBadge type="error" className="mx-2" size="sm" pill light>
          <Text type="label">Bloqueada</Text>
        </StyledBadge>
      );
    }

    return (
      <Badge className="mx-2" size="sm" pill light variant="success">
        <Text type="label">Atendida</Text>
      </Badge>
    );
  };

  return (
    <div>
      {load?.replacementOrder === 1 && (
        <Badge className="mx-2" size="sm" pill type="light">
          <Text type="label">1ª Troca de Nota</Text>
        </Badge>
      )}
      {load?.replacementOrder === 2 && (
        <Badge className="mx-2" size="sm" pill type="purple">
          <Text type="label">2ª Troca de Nota</Text>
        </Badge>
      )}
      {load?.travel && (
        <>
          {renderBadge()}
          <Link to={`/viagens/${load.travel.id}`}>
            <Text type="regular" color="light_blue">
              Viagem {load.travel.travel_number || load.travel.id}
            </Text>
            <HiOutlineExternalLink size={12} className="ml-2" />
          </Link>
        </>
      )}
    </div>
  );
}

function Details() {
  const { setEnabledToSelect, changedCompany } = useContext(UserContext);
  const freightValuesRef = useRef();
  const freightValuesReplaceRef = useRef();
  const lowerMarginModal = useModal();
  const {
    setLoadStatus,
    isTravelReproved,
    isTravelBlocked,
    setLastMarginLiberation,
    setMargins,
    fetchBusinessMarginsValues,
    shippingServiceLevelMapped,
    updateItensToFetchMargin,
    isMarginAbove,
  } = useContext(BlockedTravelContext);
  const navigate = useNavigate();
  const params = useParams();
  const attendance = useAttendance(params.id, 'LOAD', { enforceAccess: true });
  const snackbar = useSnackbar();
  const [load, setLoad] = useState();
  const [destinations, setDestinations] = useState();
  const [origins, setOrigins] = useState();
  const [isAttended, setAttended] = useState();
  const [countryList, setCountryList] = useState([]);
  const [automations, setAutomations] = useState();
  const [isLoading, setLoading] = useState(true);
  const [isInitiated, setInitiated] = useState(false);
  const [isUnauthorized, setIsUnauthorized] = useState({
    unauthorized: false,
    message: '',
  });
  const [hasPermissionToEdit, setPermissionToEdit] = useState();
  const [hasPermissionToCreate, setPermissionToCreate] = useState();
  const [showModal, setShowModal] = useState(false);
  const [editingLoadData, setEditingLoadData] = useState(false);
  const [editingMonitoringData, setEditingMonitoringData] = useState(false);
  const [policyDataTrackerOptions, setPolicyDataTrackerOptions] = useState([]);
  const [riskManagerOptions, setRiskManagerOptions] = useState([]);
  const [loadGroRequiredField, setLoadGroRequiredField] = useState({
    tracker: false,
    riskManager: false,
  });
  const [rangeId, setRangeId] = useState(null);
  const [initialRangeId, setInitialRangeId] = useState(null);
  const [newRange, setNewRange] = useState(null);
  const [groAttendedData, setGroAttendedData] = useState(null);
  const [updatedTravelData, setUpdatedTravelData] = useState(null);
  const [cargoValue, setCargoValue] = useState(0);
  const [convertedCargoValue, setConvertedCargoValue] = useState(0);
  const [loadCurrency, setLoadCurrency] = useState();
  const groModal = useModal();
  const [errors, setErrors] = useState({});
  const [tracker, setTracker] = useState();
  const attemptRegisterLoadModal = useModal();
  const [notFoundLoad, setNotFoundLoad] = useState(false);
  const [tollsPlazaInfos, setTollsPlazaInfos] = useState();
  const [oldTollsPlazaInfos, setOldTollsPlazaInfos] = useState();
  const hasPermissionToEditGROAnalysis = validatePermission(
    'EDITAR_CAMPOS_EM_VALIDACAO_GR'
  );
  const isDisabledGROAnalysis = useMemo(() => {
    if (!load?.loadPolicy) {
      return false;
    }

    if (hasPermissionToEditGROAnalysis) {
      return false;
    }

    return load?.travel?.riskApproved === UNDER_GRO_ANALYSIS_SLUG;
  }, [load?.travel?.riskApproved]);

  usePermission('VISUALIZAR_CARGAS', { redirect: true });
  async function handleGetRate(currencyValue) {
    const response = await getRate(currencyValue);
    if (!response.error && response.outdate) {
      snackbar.show(<Text>O valor do dólar informado pode não refletir a cotação atual de mercado. Recomendamos confirmar a taxa antes de realizar qualquer operação.</Text>, {
        type: 'warning',
        duration: 10000,
      });
    }
    if (!response.error) {
      return response;
    }

    snackbar.show(<Text>{response.message}</Text>, {
      type: 'error',
    });

    return null;
  }

  const [showRenewalModal, setShowRenewalModal] = useState(false);
  function handleCloseRenewalModal(backToList) {
    setShowRenewalModal(false);
    if (backToList) {
      navigate('/cargas');
    }
  }

  async function setFreightValues(loadData) {
    const rateResponse = await handleGetRate('USD');
    const props = loadToFreightData(loadData, loadData?.travel);

    await freightValuesRef.current?.init({
      ...props,
      rateResponse,
    });

    if (loadData?.isReplacement && loadData?.replacements.length > 0) {
      const replacementProps = loadReplacementToFreightData(
        loadData,
        loadData?.travel
      );
      await freightValuesReplaceRef.current?.init({
        ...replacementProps,
        rateResponse,
      });
    }
  }

  const saveTollsPlaza = async (tollsPlaza, loadId, travelId) => {
    try {
      const payload = {
        travelId: travelId || null,
        loadId: loadId,
        requestError: tollsPlaza?.requestError,
        tollsPlaza: tollsPlaza?.tollsPlaza,
        totalsTollsPlaza: {
          totalTollValue: tollsPlaza?.totalTollValue,
          totalTollTagValue: tollsPlaza?.totalTollTagValue,
          totalKm: tollsPlaza?.totalKm,
          expectedTime: tollsPlaza?.expectedTime,
          identifierHistory: tollsPlaza?.identifierHistory,
          codPolilyne: tollsPlaza?.codPolilyne,
          totalAxes: tollsPlaza?.totalAxes,
        }
      };

      const response = await cooperplaceApi.post('tollsPlaza/insert-tolls-plaza-load', payload);

      return response?.data;

    } catch (error) {
      // ignore
    }
  };

  const getTollsPlazaByLoadId = async () => {
    try {
      const response = await cooperplaceApi.get(`tollsPlaza/by-load-id/${params.id}`);
      const normalizedTollsPlaza = normalizeTollsPlazaResponse(response?.data);
      setTollsPlazaInfos(normalizedTollsPlaza);
      setOldTollsPlazaInfos(normalizedTollsPlaza);
    } catch (error) {
      snackbar.show(<Text>{error?.response?.data?.message || 'Erro ao listar as praças de pedágio'}</Text>, {
        type: 'error',
      });
    }
  };

  async function getLoad() {
    setLoading(true);
    try {
      const [response, countries] = await Promise.all([
        cooperplaceApi.get(`loads/${params.id}`),
        fetchCountries(),
      ]);
      if (response?.data?.travel) {
        await fetchBusinessMarginsValues(
          response?.data?.costCenter?.businessId
        );
        const [marginValue, advanceValue] = shippingServiceLevelMapped(
          response?.data?.travel?.shipper?.shippingCompany
            ?.descriptionServiceLevel
        );
        setMargins({
          advance_money_percentage_external:
            response?.data?.advanceMoneyPercentageExternal || advanceValue,
          benner_margin: response?.data?.travel?.benner_margin || marginValue,
        });
      }

      await updateItensToFetchMargin({
        loadId: response?.data?.id,
        mainVehicle: response?.data?.travel?.vehicle?.[0]?.vehicles || null,
        origin: response?.data?.loadOrigins[0],
        destinations: response?.data?.loadDestinations,
        shippingCompany: response?.data?.travel?.shipper?.shippingCompany,
      });

      await setFreightValues(response.data);
      setCountryList(countries);

      const toLocation = (location) => ({
        ...location,
        scheduled_time: location.scheduledTime ? moment(location.scheduledTime).format('YYYY-MM-DD HH:mm') : '',
        start_schedule: location.startSchedule ? moment(location.startSchedule).format('YYYY-MM-DD HH:mm') : '',
        identifier: location.id,
        city: location.cityModel ? location.cityModel : {
          name: location.city,
        },
        province: location.cityModel ? location.cityModel.province?.name : location.province,
        formatted_address: location.formattedAddress,
        country: countries.find(country => country.abbreviation === location.countrySlug),
        zip_code: location.zipCode,
      })

      setAutomations(response.data?.automations);
      setDestinations(response.data.loadDestinations.map(destination => ({
        ...toLocation(destination),
        type: DELIVERY_TYPE_OPTIONS.find(type => type.id === destination.action?.toLowerCase()),
      })));
      setOrigins(response.data.loadOrigins.map(origin => ({
        ...toLocation(origin),
        type: DELIVERY_TYPE_OPTIONS.find(type => type.id === 'collect'),
      })));
      setAttended(response.data.travel);
      setLoad(response.data);
      setInitiated(true);
      setCargoValue(response?.data?.cargoValue);
      setConvertedCargoValue(
        makeConversion(
          response?.data?.cargoValue,
          response?.data?.loadCurrency === 'BRL' ? '/' : '*',
          response?.data?.exchange
        )
      );
      const aux = currencyOptions.find(
        item => item.value === response?.data?.loadCurrency
      );
      setLoadCurrency(aux);
      setRangeId(response.data?.loadPolicy?.policyRangeId);
      setInitialRangeId(response.data?.loadPolicy?.policyRangeId);
      const [lastMarginLiberation] =
        response?.data?.travel?.travelMarginLiberation;
      setLastMarginLiberation(lastMarginLiberation || null);
    } catch (error) {
      if (error?.response?.status === 401) {
        setIsUnauthorized({
          unauthorized: true,
          message: error?.response?.data?.message || '',
        });
      }
      if (error?.response?.status === 404) {
        setNotFoundLoad(true);
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setPermissionToEdit(validatePermission('EDITAR_CARGAS'));
    setPermissionToCreate(validatePermission('CADASTRAR_CARGAS'));
    handleGetRate('USD');
  }, []);

  useEffect(() => {
    getLoad();
    getTollsPlazaByLoadId();
  }, [params.id, changedCompany]);

  async function updateFreightValues(freightValues, replacementPayload) {
    try {
      setLoading(true);
      const editedData = {
        toll_value: freightValues?.customer?.tollValue?.value || 0,
        action_toll: freightValues?.customer?.tollValue?.action?.id || null,
        discharge_value: freightValues?.customer?.dischargeValue?.value || 0,
        action_discharge:
          freightValues?.customer?.dischargeValue?.action?.id || null,
        charge_value: freightValues?.customer?.chargeValue?.value || 0,
        action_charge: freightValues?.customer?.chargeValue?.action?.id || null,
        ferry: freightValues?.customer?.ferry?.value || 0,
        action_ferry: freightValues?.customer?.ferry?.action?.id || null,
        ICMS: freightValues?.customer?.ICMS?.value || 0,
        action_icms: freightValues?.customer?.ICMS?.action?.id || null,
        action_griss_advalorem:
          freightValues?.customer?.gris?.action?.id || null,
        fare_company: freightValues?.fareCompany || 0,
        taker_value: freightValues?.customer?.takerValue?.value || 0,
        load_value_type: freightValues?.loadValueType?.value || null,
        gris: freightValues?.customer?.gris?.value || 0,
        ad_valorem: freightValues?.customer?.adValorem?.value || 0,
        negotiation_type: freightValues?.negotiationType?.value || null,
        freight_exchange: freightValues?.freightExchange || 0,
        currency: freightValues?.currency?.value || 'BRL',
        total_taker_value: freightValues?.customer?.total || 0,
        total_shipment_transfer: freightValues?.shipmentTransfers?.total || 0,
        total_inputs: freightValues?.discounts?.total || 0,
        total_shipment_discounts: freightValues?.shipmentDiscounts?.total || 0,
        pcp_observation:
          freightValues?.shipmentTransfers?.pcpObservation || null,
        negotiator_observation: freightValues?.shipmentTransfers?.negotiatorObservation || null,
        extra_fields:
          freightValues?.customer?.extras?.length > 0
            ? freightValues?.customer?.extras?.map(extra => {
              return {
                label: extra?.label,
                type: 0,
                value: extra?.value,
                show_to_drivers: extra?.showToDriver,
              };
            })
            : null,
        gris_percentage: freightValues?.customer?.gris?.percentage || 0,
        ad_valorem_percentage:
          freightValues?.customer?.adValorem?.percentage || null,
        icms_percentage: freightValues?.customer?.ICMS?.percentage || 0,
        replacements: replacementPayload ? [replacementPayload] : undefined,
      };

      await api.put(`v3/load/values/${load.id}`, editedData);
      let processedInputsExtraFields = [];
      if (freightValues?.discounts?.extras?.length > 0) {
        processedInputsExtraFields = [...freightValues?.discounts?.extras]?.map(
          item => {
            return {
              ...item,
              label: item.label.trim(),
              manual: true,
            };
          }
        );
      }

      processedInputsExtraFields.push({
        label: 'Seguro Coopercarga',
        manual: true,
        value: freightValues?.discounts?.coopercargaInsurance?.value,
        showToDriver: false,
      });

      let processedShipperTransferExtraFields = [];
      if (freightValues?.shipmentTransfers?.extras?.length > 0) {
        processedShipperTransferExtraFields = [
          ...freightValues?.shipmentTransfers?.extras,
        ]?.map(item => {
          return {
            ...item,
            manual: true,
            label: item.label.trim(),
          };
        });
      }

      let processedShipperDiscounts = [];
      if (freightValues?.shipmentDiscounts?.extras?.length > 0) {
        processedShipperDiscounts = [
          ...freightValues?.shipmentDiscounts?.extras,
        ]?.map(item => {
          return {
            ...item,
            label: item.label.trim(),
            manual: true,
          };
        });
      }

      const issueRateAsExtraField = {
        label: 'Taxa de emissão',
        manual: true,
        value: freightValues?.shipmentDiscounts?.issueRate,
        showToDriver: false,
      };

      processedShipperDiscounts.push(issueRateAsExtraField);

      try {
        await cooperplaceApi.put(`/carg-inputs`, {
          loadId: load.id,
          inputsExtraFields: processedInputsExtraFields,
        });
        await cooperplaceApi.put(`/carg-shipment-discounts`, {
          loadId: load.id,
          discountsExtraFields: processedShipperDiscounts,
        });
        await cooperplaceApi.put('carg-shipment-transfers', {
          loadId: load.id,
          transferExtraFields: processedShipperTransferExtraFields,
        });
      } catch (error) { }
      await getLoad();
      return true;
    } catch (error) {
      snackbar.show(
        <Text>
          {error?.response?.data?.error || error?.response?.data?.message ||
            'Algo deu errado ao atualizar a carga, tente novamente.'}
        </Text>,
        {
          type: 'error',
        }
      );
      return false;
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmitFreightValues({ confirmMinimiumMargin }) {
    const freightValues = await freightValuesRef?.current?.getValues();
    const freightReplacementValues =
      await freightValuesReplaceRef?.current?.getValues();

    if (!freightValues) {
      snackbar.show(<Text>Verifique os campos obrigatórios.</Text>, {
        type: 'error',
      });

      return false;
    }

    if (load?.isReplacement && !freightReplacementValues) {
      snackbar.show(
        <Text>Verifique os campos obrigatórios da troca de nota!</Text>,
        {
          type: 'error',
        }
      );

      return false;
    }

    const replacementPayload =
      load?.isReplacement &&
      freightReplacementValues &&
      toReplacementPayload(freightReplacementValues);

    try {
      const actualMargin =
        ((Number(freightValues?.fareCompany || 0) -
          Number(load?.attended?.balance || 0)) /
          Number(freightValues?.fareCompany || 0)) *
        100;

      if (!confirmMinimiumMargin && load?.attended?.id) {
        const isMarginERPAbove = await isMarginAbove({
          actualMargin,
          isFreightValues: true,
        });

        if (isMarginERPAbove) {
          lowerMarginModal.open();
          return false;
        }
      }

      const updated = await updateFreightValues(freightValues, replacementPayload);

      if (!updated) {
        return false;
      }

      snackbar.show(<Text>Composição de valores de frete salva com sucesso!</Text>, {
        type: 'success',
      });

      return updated;
    } catch (err) {

      return false;
    }
  }

  useEffect(() => {
    setIsUnauthorized({
      unauthorized: false,
      message: '',
    });
  }, [changedCompany]);

  useEffect(() => {
    if (load) {
      setDestinations(load.loadDestinations);
      setOrigins(load.loadOrigins);
    }
  }, [setLoad]);

  const handleCloseModal = () => setShowModal(false);
  function handleCancelLoad() {
    setShowModal(true);
  }

  function onGoingTravelStatusId(id) {
    return [3, 4, 5, 6, 7, 10, 12].includes(id);
  }

  function snackbarShow(text, typeShow) {
    snackbar.show(<Text className="text-center">{text}</Text>, {
      type: typeShow,
      duration: 5000,
    });
  }

  async function getLoadPolicyRangeData(policyId, rgId) {
    try {
      const { data } = await cooperplaceApi.get(
        `policies/${policyId}/ranges/${rgId}`
      );
      const managerTrackers = data?.groups?.find(
        item => item?.code === 'manager_tracker'
      )?.items;
      const tecnologies = data?.equipments_groups
        .map(group => group.tecnologies)
        ?.flatMap(tec => tec);
      setPolicyDataTrackerOptions(tecnologies);
      setRiskManagerOptions(managerTrackers);
    } catch (error) {
      snackbar.show(
        <Text>
          Não foi possível recuperar opções da faixa da apólice da carga! Tente
          novamente mais tarde
        </Text>,
        { type: 'warning' }
      );
      setEditingLoadData(false);
    }
  }

  useEffect(() => {
    if (load?.loadPolicy?.id && (editingLoadData || editingMonitoringData)) {
      getLoadPolicyRangeData(
        load?.loadPolicy?.id,
        load?.loadPolicy?.policyRangeId
      );
    }
  }, [load?.loadPolicy, editingLoadData, editingMonitoringData]);

  useEffect(() => {
    if (load?.travel?.status) setLoadStatus(load.travel.travelStatus);
    if (!load?.travel) setLoadStatus({});
  }, [load]);

  useEffect(() => {
    if (!isUnauthorized.unauthorized) {
      setEnabledToSelect(false);
    }
  }, [isUnauthorized.unauthorized]);

  async function handleCancelGroAttendedModal() {
    try {
      await getLoad();
      setEditingLoadData(false);
      setGroAttendedData(null);
      setRangeId(initialRangeId);
      setCargoValue(null);
      groModal.close();
    } catch (error) {
      //
    }
  }

  const lastDestination = useMemo(() => {
    if (destinations?.length > 0) {
      return destinations?.[destinations?.length - 1];
    }

    return null;
  }, [destinations]);

  const isNational = useMemo(() => {
    if (!origins?.length || !lastDestination) return false;
    const origin = origins?.[0];
    return origin?.countrySlug === 'br' && lastDestination?.countrySlug === 'br';
  }, [origins, lastDestination]);

  const cargoValueInReal = useMemo(() => {
    if (loadCurrency?.value === 'BRL') {
      return cargoValue;
    }

    return convertedCargoValue;
  }, [cargoValue, loadCurrency?.value, convertedCargoValue]);

  if (notFoundLoad) {
    return (
      <ApplicationLayout>
        <Card>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: 6 }}
            className="text-center"
          >
            <Text type="header" color="error">
              <FaExclamationCircle
                size={26}
                color="#F64E60"
                className="mr-2 mb-1"
              />
              Essa carga não existe!
            </Text>
          </div>
        </Card>
      </ApplicationLayout>
    );
  }

  if (isUnauthorized.unauthorized) {
    setEnabledToSelect(true);
    return (
      <ApplicationLayout>
        <Card>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: 6 }}
            className="text-center"
          >
            <Text type="header" color="error">
              <FaExclamationCircle
                size={26}
                color="#F64E60"
                className="mr-2 mb-1"
              />
              Você não tem permissão para acessar essa carga!
            </Text>
            <Text type="header" color="error">
              {isUnauthorized.message}
            </Text>
          </div>
        </Card>
      </ApplicationLayout>
    );
  }

  function handleCheckIfClientHasActiveAndNotExpired(activePolicies) {
    const notExpiredPolicies = activePolicies.some(policy => {
      return !policy.expired;
    });
    return notExpiredPolicies;
  }

  function handleCheckIfClientHasActivePolicies(policies) {
    const activePolicies = policies?.filter(policy => policy.active === true);
    return {
      hasActive: activePolicies?.length > 0,
      activePolicies,
    };
  }

  async function handleCheckIfClientHasPolicies(loadData) {
    try {
      setLoading(true);
      const { data } = await cooperplaceApi.get(
        `clients/${loadData?.taker?.id}/policies`
      );

      const { hasActive, activePolicies } =
        handleCheckIfClientHasActivePolicies(data);

      if (!hasActive) {
        snackbar.show(
          <Text>
            Cliente sem apólices ativas!
          </Text>,
          {
            type: 'error',
          }
        );

        navigate(`/cargas/cadastrar/${load?.id}`);

      }
      const hasNotExpiredPolicies =
        handleCheckIfClientHasActiveAndNotExpired(activePolicies);

      if (!hasNotExpiredPolicies) {
        snackbar.show(
          <Text>
             Apólices para o cliente {loadData?.taker?.socialName} estão vencidas!
          </Text>,
          {
            type: 'error',
          }
        );
        setLoading(false);

        navigate(`/cargas/cadastrar/${load?.id}`);
      } else {
        snackbar.show(
          <Text>
            Cliente com apólices vigentes! Você será redirecionado para criação
            de carga com apólices
          </Text>,
          {
            type: 'success',
          }
        );
        setLoading(false);
        navigate(`/cargas/cadastrar/gro/${loadData?.id}`, {
          state: {
            clientData: loadData?.taker,
            clientPolicies: activePolicies?.filter(
              policy => !policy.expired && policy.active
            ),
          },
        });
      }
    } catch (err) {
      snackbar.show(<Text>Falha ao consultar apólices do cliente!</Text>, {
        type: 'error',
      });
      setLoading(false);
    }
  }


  async function handleDuplicateLoad() {
    if (!load) return;

    if (load?.loadPolicy) {
      await handleCheckIfClientHasPolicies(load);
    } else {
      navigate(`/cargas/cadastrar/${load?.id}`);
    }
  }

  return (
    <ApplicationLayout
      title="Detalhes da carga"
      RightComponent={
        <>
          <Button
            variant="secondary"
            onClick={() => navigate(-1)}
            className="ml-2"
          >
            <Text weight={500} type="regular">
              Voltar
            </Text>
          </Button>
          <DropdownButton
            disabled={isLoading}
            style={{ display: 'inline', marginLeft: 10 }}
            title="Opções"
            variant="primary"
            className="ml-2"
            id="button-opcoes-carga"
            options={[
              {
                title: 'Atender Carga',
                onClick: () => {
                  const isValidated = validateStartSchedule(
                    load.dueDate,
                    load.loadOrigins[0].scheduledTime,
                    load.loadDestinations[load.loadDestinations.length - 1]
                      .scheduledTime,
                    snackbarShow,
                    load?.costCenter.limitSchedule
                  );

                  const isGROLoadAndValid =
                    load?.loadPolicy?.id &&
                    validatePolicyValidity(
                      load?.loadPolicy?.policy?.dueDate,
                      snackbarShow
                    );

                  if (load?.loadPolicy?.id && !isGROLoadAndValid) {
                    return;
                  }

                  if (isValidated === true) {
                    validateBranchOffice(
                      (path) => navigate(attendance.path(path)),
                      snackbarShow,
                      load?.branchOffice?.active,
                      load.id
                    );
                  }
                },
                disabled: (load && load.travel) || (load && load.deletedAt) || (Boolean(attendance.error) || attendance.accessPending),
                type: 'item',
                id: 'button-opcoes-carga-atender',
              },
              {
                title: 'Duplicar Carga',
                onClick: handleDuplicateLoad,
                disabled:
                  !load ||
                  !hasPermissionToCreate ||
                  (load?.userCreated?.id === 183 || load?.userCreated?.id === 1) ||
                  (!load?.isReplacement && load?.replacementOrder === 2),
                type: 'item',
                id: 'button-opcoes-carga-duplicar',
              },
              {
                title: 'Renovar Carga',
                onClick: () => setShowRenewalModal(true),
                disabled:
                  !validatePermission('CADASTRAR_CARGAS') ||
                  (load?.travel && load.travel.statusId !== 7),
                type: 'item',
                id: 'button-opcoes-carga-renovar',
              },
              {
                title: 'Cancelar Carga',
                onClick: () => handleCancelLoad(),
                disabled:
                  !hasPermissionToEdit ||
                  (load && load.deletedAt) ||
                  (load && load.travel && load.travel.statusId !== 7),
                type: 'item',
                id: 'button-opcoes-carga-cancelar',
              },
              {
                type: 'divider',
              },
              {
                title: 'Nova Carga',
                onClick: () => attemptRegisterLoadModal.open(),
                disabled: !hasPermissionToCreate,
                type: 'item',
                id: 'button-opcoes-carga-nova',
              },
            ]}
          />
        </>
      }
    >
      <AttemptRegisterLoad
        isOpen={attemptRegisterLoadModal.isOpen}
        onClose={() => attemptRegisterLoadModal.close()}
      />
      <GroAttended
        loading={isLoading}
        isOpen={groModal.isOpen}
        modalHook={groModal}
        onClose={handleCancelGroAttendedModal}
        groAttendedData={groAttendedData}
        setGroAttendedData={setGroAttendedData}
        newRange={newRange}
        handleCancel={handleCancelGroAttendedModal}
        setUpdatedTravelData={setUpdatedTravelData}
      />
      <CancelLoad
        loadId={params.id}
        handleClose={handleCloseModal}
        show={showModal}
        onConfirm={confirmOption}
      />
      <ModalRenewLoad
        show={showRenewalModal}
        load={load}
        loadId={params.id}
        dueDate={load?.dueDate}
        handleClose={handleCloseRenewalModal}
        backToListOption
      />

      <AttendanceNotice attendance={attendance} busy={isLoading} />
      <Row>
        <Col xs={12}>
          <Card>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <Text id="label-numero-carga" color="#464E5F" type="header">
                  Número {load?.id}
                </Text>
                {!!load?.deletedAt && (
                  <div>
                    <StyledBadge pill light type="error" className="ml-2">
                      <Text type="label">Cancelada</Text>
                    </StyledBadge>
                  </div>
                )}
                <RenderLoadLabel
                  isTravelBlocked={isTravelBlocked}
                  isTravelReproved={isTravelReproved}
                  load={load}
                />
              </div>
              {load ? (
                <Text
                  id="label-criado-por"
                  type="label"
                  color="gray"
                  className="pr-2"
                >
                  Criado por {load?.userCreated.username} -{' '}
                  {moment.utc(load?.createdAt).format('DD/MM/YYYY')}
                </Text>
              ) : null}
            </div>
            {load?.attended && (
              <div className="d-flex align-items-center justify-content-between">
                <Text />
                <Text type="label" color="gray" className="pr-2">
                  Atendido por {load?.attended?.userCreated.username} -{' '}
                  {moment.utc(load?.attended?.created_at).format('DD/MM/YYYY')}
                </Text>
              </div>
            )}
          </Card>
        </Col>
      </Row>
      <Row xs={12} md={12}>
        <Col xs={12} md={6}>
          <Data
            onGoingTravelStatusId={onGoingTravelStatusId}
            load={load}
            getLoad={getLoad}
            loadingCard={isLoading}
            editingLoadData={editingLoadData}
            setEditingLoadData={setEditingLoadData}
            setLoad={setLoad}
            riskManagerOptions={riskManagerOptions}
            setRiskManagerOptions={setRiskManagerOptions}
            loadGroRequiredField={loadGroRequiredField}
            setLoadGroRequiredField={setLoadGroRequiredField}
            errors={errors}
            setErrors={setErrors}
            tracker={tracker}
            setTracker={setTracker}
            rangeId={rangeId}
            setRangeId={setRangeId}
            initialRangeId={initialRangeId}
            setNewRange={setNewRange}
            groModal={groModal}
            setGroAttendedData={setGroAttendedData}
            cargoValue={cargoValue}
            setCargoValue={setCargoValue}
            convertedCargoValue={convertedCargoValue}
            setConvertedCargoValue={setConvertedCargoValue}
            loadCurrency={loadCurrency}
            setLoadCurrency={setLoadCurrency}
            updatedTravelData={updatedTravelData}
            setUpdatedTravelData={setUpdatedTravelData}
            isDisabledGROAnalysis={isDisabledGROAnalysis}
            updateFreightValues={updateFreightValues}
            freightValuesRef={freightValuesRef}
            freightValuesReplaceRef={freightValuesReplaceRef}
          />
        </Col>
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12}>
              <Vehicle
                onGoingTravelStatusId={onGoingTravelStatusId}
                load={load}
                getLoad={getLoad}
                loadingCard={isLoading}
                isDisabledGROAnalysis={isDisabledGROAnalysis}
                freightValuesRef={freightValuesRef}
                updateFreightValues={updateFreightValues}
                freightValuesReplaceRef={freightValuesReplaceRef}
                saveTollsPlaza={saveTollsPlaza}
                tollsPlazaInfos={tollsPlazaInfos}
                setTollsPlazaInfos={setTollsPlazaInfos}
                oldTollsPlazaInfos={oldTollsPlazaInfos}
                getTollsPlazaByLoadId={getTollsPlazaByLoadId}
              />
            </Col>
            <Col xs={12}>
              <Monitoring
                load={load}
                getLoad={getLoad}
                loadingCard={isLoading}
                onGoingTravelStatusId={onGoingTravelStatusId}
                editingMonitoringData={editingMonitoringData}
                setEditingMonitoringData={setEditingMonitoringData}
                errors={errors}
                setErrors={setErrors}
                policyDataTrackerOptions={policyDataTrackerOptions}
                tracker={tracker}
                setTracker={setTracker}
                isDisabledGROAnalysis={isDisabledGROAnalysis}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {isInitiated && (
            <Locale
              originsData={origins}
              destinationsData={destinations}
              loadId={params.id}
              loadingCard={isLoading}
              isAttended={isAttended}
              getLoad={getLoad}
              setLoad={setLoad}
              countryList={countryList}
              groLoadData={
                load?.loadPolicy?.policyId
                  ? {
                    policyId: load?.loadPolicy?.policyId,
                    operationId: load?.loadPolicy?.policyOperationId,
                    productId: load?.product?.id,
                  }
                  : null
              }
              isDisabledGROAnalysis={isDisabledGROAnalysis}
              freightValuesRef={freightValuesRef}
              freightValuesReplaceRef={freightValuesReplaceRef}
              updateFreightValues={updateFreightValues}
              polylineRoute={load?.polilyneRoute || null}
              preSMData={load?.travel?.presm}
              load={load}
              saveTollsPlaza={saveTollsPlaza}
              tollsPlazaInfos={tollsPlazaInfos}
              setTollsPlazaInfos={setTollsPlazaInfos}
              getTollsPlazaByLoadId={getTollsPlazaByLoadId}
            />
          )}
        </Col>
      </Row>
      <Row>
        <FreightValues
          freightValuesRef={freightValuesRef}
          freightValuesReplaceRef={freightValuesReplaceRef}
          cargoValue={cargoValueInReal}
          totalKm={tollsPlazaInfos?.totalKm}
          disableEditing={onGoingTravelStatusId(load?.attended?.status_id)}
          handleSubmit={() =>
            handleSubmitFreightValues({
              confirmMinimiumMargin: false,
            })
          }
          isLoading={isLoading}
          isReplacement={load?.isReplacement}
          showHeaderButtons
          isNational={isNational}
        />
        <Integrations
          onGoingTravelStatusId={onGoingTravelStatusId}
          load={load}
          loadId={params.id}
          loadingCard={isLoading}
        />
        <Automations
          onGoingTravelStatusId={onGoingTravelStatusId}
          load={load}
          getLoad={getLoad}
          loadId={params.id}
          loadingCard={isLoading}
          automations={automations}
        />
        <Visualizations
          loadId={params.id}
          isAttended={isAttended}
          loadingCard={isLoading}
        />
        <MinimumMarginModal
          isOpen={lowerMarginModal.isOpen}
          onClose={lowerMarginModal.close}
          confirm={handleSubmitFreightValues}
        />
      </Row>
    </ApplicationLayout>
  );
}

export default function LoadDetails() {
  return (
    <InsuranceValueContextProvider>
      <Details />
    </InsuranceValueContextProvider>
  );
}
